import {
    Modal, Button, ModalHeader, ModalBody, ModalFooter, Badge,
} from 'appkit-react';

import '../styles/ruleResetWarningModal.scss';

const RuleResetWarningModal = ({
    showResetModal, setShowResetModal, setConfirmReset,
}) => (
    <div className="true-comply__datarecon-dataquality-rule_reset_warning_modal">
        <Modal
            className="action-modal-showcase"
            visible={showResetModal}
            onCancel={() => setShowResetModal(false)}
        >
            <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <Badge className="example-badge" type="warning">WARNING</Badge>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <div
                    className="true-comply__datarecon-dataquality-rule_reset_warning_modal_description"
                >
                    This action will reset the selected rules. Are you sure you want to proceed ?
                </div>
            </ModalBody>
            <ModalFooter className="a-apply-theme-border-top-gray-level-6">
                <div className="button-comp">
                    <Button
                        kind="transparent"
                        gray
                        onClick={
                            () => {
                                setConfirmReset(false);
                                setShowResetModal(false);
                            }
                        }
                        size="lg"
                    >
                        NO
                    </Button>
                    <Button
                        kind="transparent"
                        onClick={
                            () => {
                                setConfirmReset(true);
                                setShowResetModal(false);
                            }
                        }
                        size="lg"
                    >
                        YES
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    </div>
);

export default RuleResetWarningModal;
